import { getAllMfData } from './helpers/index.js';
import CanaryManager from './CanaryManager/canaryManager.js';
import { ManifestHandler } from './mf/manifestHandler.js';
import GlobalSharedDependenciesManager, { addSharedDepepndenciesToWindow } from './SharedDependenciesManager/GlobalSharedDependenciesManager.js';
import { SkeletonEvent } from '../types.js';
import { getMFTestVersionFromURLParams } from './helpers/queryHelper.js';

async function preload({ mfsToPreload, isAssetsFlattened, mfUrl, onError, testOverridesQueryParams = getMFTestVersionFromURLParams(), }) {
    const preloadTiming = { preloadStartTime: Date.now() };
    const canaryManager = new CanaryManager();
    const globalSharedDependenciesManager = new GlobalSharedDependenciesManager();
    const manifestHandler = new ManifestHandler({
        emitSkeletonEvent: (eventName, data = {}) => {
            if (eventName === SkeletonEvent.ErrorLoadingJSAsset || eventName === SkeletonEvent.ErrorLoadingCSSAsset) {
                onError(new Error(`${eventName}: ${data.src}`));
            }
        },
        sharedDependencies: globalSharedDependenciesManager,
    });
    const allMfDataStartTime = Date.now();
    const allMfData = await getAllMfData({
        mfsToPreload,
        ...(testOverridesQueryParams ? { testOverridesQueryParams } : {}),
        isAssetsFlattened,
        mfUrl,
    });
    preloadTiming.allMfDataLoadTime = Date.now() - allMfDataStartTime;
    const { preloadedSharedDependencyBuckets = [], preloadedEntrypoints = [], metaData } = allMfData;
    const mfAssets = [];
    preloadedEntrypoints.forEach(({ entrypoints, canaryEntrypoints, name }) => {
        const isInCanary = canaryEntrypoints && canaryManager.isInCanary(name, metaData[name].canary);
        const mfMetaData = isInCanary ? metaData[name].canary : metaData[name];
        const entrypointsToLoad = isInCanary ? canaryEntrypoints : entrypoints;
        mfAssets.push(...entrypointsToLoad.map(entrypoint => `${mfMetaData.assetsPath || mfMetaData.path}/${entrypoint}`));
    });
    globalSharedDependenciesManager.addKnownDependencies(preloadedSharedDependencyBuckets.flat());
    try {
        const { assetsLoadTime } = await manifestHandler.batchLoadMfsAssets({
            mfNames: mfsToPreload,
            mfAssets,
            sharedDependenciesBuckets: preloadedSharedDependencyBuckets,
        });
        preloadTiming.assetsLoadTime = assetsLoadTime;
    }
    catch (e) {
        console.error('Failed to preload assets', e);
        return Promise.reject(e);
    }
    const preloadedSharedDependencies = preloadedSharedDependencyBuckets.flat().reduce((acc, { globalName, url }) => {
        acc[globalName] = url;
        return acc;
    }, {});
    // mark preloaded shared dependencies as loaded
    addSharedDepepndenciesToWindow(preloadedSharedDependencies);
    // mark preloaded mfs entries as loaded
    window.microfrontends.preloaded_mfs_entries = preloadedEntrypoints.reduce((acc, { name, entrypoints }) => {
        acc[name] = entrypoints;
        return acc;
    }, {});
    // expose allMfData to window to be used in skeleton
    window.microfrontends.allMfData = allMfData;
    preloadTiming.totalPreloadTime = Date.now() - preloadTiming.preloadStartTime;
    return preloadTiming;
}

export { preload };
